<template>
  <hsc-window-style-white style="z-index:7" >
      <hsc-window :title="$t(currentMovableDialog.titleKey)" :closeButton="true" :isOpen.sync="isOpen" >
          <component :is="currentMovableDialog.cmp" :uiid="currentMovableDialog.uiid" :refresh="isOpen"></component>          
      </hsc-window>      
  </hsc-window-style-white>
</template>
<script>
  import { mapGetters } from 'vuex'  
  //inclure ici tous les composants possible a incorporer dans la fenetre de dialogue  
  import DepthProfilDialog from '@/components/map/DepthProfilDialog'
  import ChartConfig from '@/components/charts/ChartConfig'

  export default {
    components: {DepthProfilDialog,ChartConfig},
    name: 'AppMovableDialogContainer',     
    computed: {
       ...mapGetters([
         'currentMovableDialog'
        ]),
        isOpen:{
          get(){
            return this.currentMovableDialog.isVisible
          },
          set(newValue){
            this.$store.myActions.UI_SET_MOVABLE_DIALOG_VISIBILITY(newValue)
          }
        }         
    },
    methods: {      
    }
  }
</script>
<style scope>
.content{
  background-color: #fff;
}
</style>